
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/concierge",
      function () {
        return require("private-next-pages/stores/[cName]/concierge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/concierge"])
      });
    }
  